import { GridCellProps } from '@progress/kendo-react-grid';
import { SwitchChangeEvent } from '@progress/kendo-react-inputs';
import { useCallback } from 'react';
import Switch from 'src/components/design-system/Switch';
import GridCellBase from 'src/components/GridCellBase';

const AppendSequenceCell = (props: GridCellProps) => {
  const { dataItem, onChange, dataIndex, field } = props;
  const isItemOrDescription =
    dataItem.field === 'productItemNum' || dataItem.field === 'description';
  const isDisabled = !dataItem.selected;
  const handleChange = useCallback(
    (e: SwitchChangeEvent) => {
      onChange?.({
        dataIndex: dataIndex,
        dataItem: dataItem,
        field: field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  const tooltip = dataItem?.appendLineItem ? 'true' : 'false';

  return (
    <GridCellBase
      {...props}
      className={'!bg-transparent !text-center'}
      title={tooltip}
      disableToolTip={!isItemOrDescription}
    >
      {isItemOrDescription ? (
        <Switch
          id="invoiceSwitch"
          value={!!dataItem?.appendLineItem}
          onLabel="YES"
          offLabel="NO"
          onChange={handleChange}
          size="medium"
          disabled={isDisabled}
        />
      ) : (
        <></>
      )}
    </GridCellBase>
  );
};

export default AppendSequenceCell;
